import { useLayoutEffect, useState } from 'react';
import Map from 'eemovel-map-library/src/data/google-maps/map';
import { useSelector } from 'react-redux';
import { boundBoxToLatLngBounds } from '../controllers/citySelect.controller';

const useMapBounds = () => {
  const { selectedCity } = useSelector((state: any) => state.mapSearch);
  const [newBound, setNewBound] = useState<
    google.maps.LatLngBoundsLiteral | undefined
  >(selectedCity && boundBoxToLatLngBounds(selectedCity.bound_box[0]));

  useLayoutEffect(() => {
    if (selectedCity) {
      const { bound_box } = selectedCity;
      setNewBound(boundBoxToLatLngBounds(bound_box[0]));
    }
  }, [selectedCity]);

  useLayoutEffect(() => {
    Map.currentBounds = newBound;
  }, [newBound]);

  return newBound;
};

export default useMapBounds;
